import { render, staticRenderFns } from "./RequestQuotation.vue?vue&type=template&id=98c01972"
import script from "./RequestQuotation.vue?vue&type=script&lang=js"
export * from "./RequestQuotation.vue?vue&type=script&lang=js"
import style0 from "./RequestQuotation.vue?vue&type=style&index=0&id=98c01972&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports